import { Pipe, Inject, PLATFORM_ID, transition } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { TypeformService } from 'angular-engine/engine/service/util/typeform.service';
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'typeform',
  pure: true
})
export class TypeformPipe {

  private isServer:boolean;
  constructor(@Inject(PLATFORM_ID) private platformId: string,
            private sanitized: DomSanitizer,
            private typeformService: TypeformService) { 
    this.isServer = isPlatformServer(this.platformId);
  }

  ngAfterViewInit() {
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
      
  }
  handleTypeforms(string) {
    if(!this.isServer)
    {
    let that = this;
    var parser = new DOMParser();
    
    var typeforms = parser.parseFromString(string, 'text/html').getElementsByClassName('typeform');
    var results = [];

    for (var i = 0; i < typeforms.length; i++) {
      var mode = typeforms[i].getAttribute('data-mode'); 
      var src = typeforms[i].getAttribute('data-url');
      var id = typeforms[i].getAttribute('id');
      var opacity = typeforms[i].getAttribute('data-transparency');
      var header = typeforms[i].getAttribute('data-hide-headers');
      var footer = typeforms[i].getAttribute('data-hide-footer');
      
      var obj = {mode:mode, src:src, id:id, opacity:opacity, header:header, footer:footer};

      if (src.length && results.indexOf(obj) === -1) {
        results.push(obj);
      }
    }

    
        if(!document.getElementById("typef_orm"))
        {
            this.createTypeformScript();
        }
        else{
            this.typeformService.typeforms = results;
        }
    
    }
  }

  createTypeformScript(){
    var script = document.createElement('script');
    script.setAttribute('src', 'https://embed.typeform.com/embed.js');
    script.setAttribute('id', 'typef_orm');
    document.body.appendChild(script);
  }

  


  transform(htmlContent: any) {
    this.handleTypeforms(htmlContent);
    return this.sanitized.bypassSecurityTrustHtml(htmlContent);
  }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/typeform.pipe.ts